<template>
  <div class="page-404">
    <header class="brand-header">
      <img src="../../assets/images/logo/logo.png" alt="Orderly" class="brand-logo" />
    </header>

    <main class="content">
      <section class="illustration" aria-hidden="true">
        <div class="glow glow-primary"></div>
        <div class="glow glow-accent"></div>

        <div class="floating-card-wrap">
          <div class="paper-card">
            <div class="line line-lg"></div>
            <div class="line line-md"></div>
            <div class="line line-sm"></div>
              <div class="broken-link">
                <i class="fa fa-chain-broken" aria-hidden="true"></i>
              </div>
          </div>

          <div class="shape blob"></div>
          <div class="shape dot"></div>
          <div class="shape sheet"></div>
          <div class="shape diamond"></div>
        </div>
      </section>

      <section class="copy">
        <h1 class="code">404</h1>
        <h2 class="title">Pagina no encontrada</h2>
        <p class="description">
          {{ description }}
        </p>

        <div class="actions">
          <button class="btn btn-primary" type="button" @click="redirectNow">
            Ir al Inicio
          </button>
          <button class="btn-back" type="button" @click="goBack">
            <i class="fa fa-arrow-left btn-icon" aria-hidden="true"></i>
            <span>Volver atrás</span>
          </button>
        </div>
      </section>
    </main>

    <footer class="error-footer">&copy; 2024 Orderly. Todos los derechos reservados.</footer>
  </div>
</template>

<script>
export default {
  name: 'error-404',
  computed: {
    description() {
      if (this.$route.name === 'invalidDomain') {
        return 'El dominio no esta autorizado para esta cuenta. Verifica tu URL o contacta a soporte.';
      }

      return 'Lo sentimos, la pagina que buscas parece haber sido movida o no existe. Te llevaremos a un lugar seguro.';
    },
  },
  methods: {
    redirectNow() {
      const token = localStorage.getItem('access_token');
      const user = localStorage.getItem('user');
      const isLoggedIn = !!token && token !== 'undefined' && !!user && user !== 'undefined';

      this.$router.replace(isLoggedIn ? { name: 'home' } : { name: 'login' });
    },
    goBack() {
      window.history.back();
    },
  },
};
</script>
